import React from 'react';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import BarGraph from '../../../../graphs/BarGraph';
import { DateRange } from '../../../../redux/dateRangeSlice';
import LineGraph from '../../../../graphs/LineGraph';
import Colors from '../../../../constants/Colors';
import TimeIcon16 from '../../../16pxIcons/TimeIcon16';
import { ChartDataPoint } from '../../../../graphs/axisUtils';
import { getRangeHours } from '../../../../constants/Utils';

interface TimeComparisonGraphProps {
  hoursBookedData: ChartDataPoint[],
  timeSpentData: ChartDataPoint[],
  hoursBookedDataCompared: ChartDataPoint[],
  timeSpentDataCompared: ChartDataPoint[],
}

const TimeComparisonGraph = ({
  hoursBookedData: chartData, timeSpentData: alternateData,
  hoursBookedDataCompared: comparisonData, timeSpentDataCompared: alternateComparisonData,
}: TimeComparisonGraphProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const compareRange: DateRange = useSelector((state:
    { dateComparisonRange: DateRange }) => (state.dateComparisonRange));
  const showBarGraph: boolean = !(!!compareRange.start && !!compareRange.end)
    && getRangeHours(range) / 24 < 8;
  const unit: string = getRangeHours(range) > 24 ? 'Hours' : 'Minutes';
  const title: string = 'Booked time';
  const alternateTitle: string = 'Time occupied';

  return <SpaceUtilizationWidget
    icon={<TimeIcon16 />}
    title='Booked time vs time spent'
    content={showBarGraph ? <BarGraph
      {...{
        unit, title, alternateTitle, chartData, alternateData, range,
      }}
      selectedColor={Colors.light.hereworksDarkBlue300}
      alternateColor={Colors.light.hereworksDarkBlue100}
      chartHeight={315}
      horizontalTickCount={12}
      style={styles.barGraph}
      showLabels={false}
      stackAlternate
      showLegend
      hideTimeOnTooltip
    /> : <LineGraph
      {...{
        unit,
        title,
        alternateTitle,
        chartData,
        alternateData,
        range,
        comparisonData,
        alternateComparisonData,
      }}
      alternateColor={Colors.light.hereworksBlue100}
      noTitle
      chartHeight={420}
      style={styles.lineGraph}
      showLegend
      hideTimeOnTooltip
      domainYLimit={24}
    />}
  />;
};

const styles = StyleSheet.create({
  barGraph: {
    marginStart: -12,
  },
  lineGraph: {
    marginTop: -70,
    marginStart: -24,
    marginEnd: 20,
  },
});

export default TimeComparisonGraph;
